// utils/checkDataset.js

export const isDatasetEmptyOrNull = (datasetString) => {
  if (!datasetString) return true; // Check if datasetString is null or undefined

  try {
    const dataset = JSON.parse(datasetString); // Parse the dataset string

    // Check if the dataset is empty or meets the null/empty criteria for each dataset type
    return dataset.every((entry) => {
      // For trialDataSetList
      if (entry.trialDataList) {
        return entry.trialDataList.every(
          (trial) => trial.prompt === null || trial.result === null
        );
      }

      // For percentDataSet
      if (entry.percent !== undefined) {
        return entry.percent === null && entry.prompt === null;
      }

      // For durationDataSetList
      if (entry.duration !== undefined) {
        return entry.duration === 0;
      }

      // Default case (if no recognized dataset structure is found)
      return false;
    });
  } catch (error) {
    console.error("Error parsing dataset:", error);
    return true; // Consider invalid JSON as empty
  }
};
